import React from 'react';
import styled from 'styled-components';
import {
  BodyText,
  FlexColumn,
  FlexRow,
  formatNumber,
  useMatchMedia
} from '@make-software/cspr-design';
import { GroupByFilter } from 'app/components/filters/group-by-filter';
import { PeriodFilter } from 'app/components/filters/period-filter';
import { EventsGroupBy } from 'app/console-api/statistics/types';

const ChartHeaderContainer = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    flexDirection: ['column', 'column', 'row', 'row'],
    width: '100%',
    justifyContent: 'space-between',
    '& > * + *': {
      marginTop: [16, 16, 0]
    }
  })
);

const ChartFiltersContainer = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    justifyContent: 'space-between',
    alignItems: 'center',
    '& > * + *': {
      marginLeft: 32
    }
  })
);

const DropdownWrapper = styled.div(({ theme }) =>
  theme.withMedia({
    position: 'relative',

    '& > div[role="combobox"]': {
      width: '100%'
    },

    '& > div[role="combobox"] > div[role="button"]': {
      height: '30px'
    },

    '& > div[role="combobox"] > div[role="listbox"]': {
      position: 'absolute',
      zIndex: 1000,
      width: '100%'
    }
  })
);

export interface ChartHeaderProps {
  title: string;
  totalRequests: number;
  optionsList: EventsGroupBy[];
  totalLabel?: string;
}

export const ChartHeader = ({
  title,
  totalRequests,
  optionsList,
  totalLabel
}: ChartHeaderProps) => {
  const screenType = useMatchMedia(['mobile', 'tabletOrAbove'], []);

  return (
    <ChartHeaderContainer>
      <FlexColumn>
        <BodyText scale={'xl'} size={1} variation="black" noWrap>
          {title}
        </BodyText>
        <FlexRow itemsSpacing={4} align="center">
          <BodyText size={3} scale={'md'} variation={'darkGray'}>
            {totalLabel || 'Total'}:
          </BodyText>
          <BodyText size={2} scale={'md'} variation={'black'}>
            {formatNumber(totalRequests)}
          </BodyText>
        </FlexRow>
      </FlexColumn>
      <ChartFiltersContainer>
        <FlexRow justify={'start'} align="center" gap={8}>
          {screenType !== 'mobile' && (
            <BodyText size={3} scale={'xs'} variation={'darkGray'}>
              Group by:
            </BodyText>
          )}
          <DropdownWrapper>
            <GroupByFilter optionsList={optionsList} />
          </DropdownWrapper>
        </FlexRow>
        <PeriodFilter />
      </ChartFiltersContainer>
    </ChartHeaderContainer>
  );
};

type RequestCountChartHeaderProps = {
  title: string;
  totalRequests: number;
  optionsList: EventsGroupBy[];
};

export const RequestCountChartHeader = (props: RequestCountChartHeaderProps) => {
  return <ChartHeader {...props} totalLabel={'Total events'} />;
};
